module.exports = __webpack_public_path__ + "img/zhongshanjiliantang.ce24fc5a.jpg";